/**
 * noncompliantResourcesIgnored模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const noncompliantResourcesIgnored = {
    //分页
    page(params) {
        return $http.post(`${global.API_URL}/sme/noncompliantResourcesIgnored/page`,params);
    },
    //忽略
    ignoreNoncompliantResources(params) {
        return $http.post(`${global.API_URL}/sme/noncompliantResourcesIgnored/ignoreNoncompliantResources`,params);
    },
    //恢复
    deleteIgnoreNoncompliantResources(params) {
        return $http.post(`${global.API_URL}/sme/noncompliantResourcesIgnored/deleteIgnoreNoncompliantResources`,params);
    }
}

export default noncompliantResourcesIgnored;



// WEBPACK FOOTER //
// ./src/api/noncompliantResourcesIgnored.js